import { Component, Input, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AnnualVacationQuotaModel } from '../../../../core/models/user/annual-vacation-quota.model';
import { UserService } from '../../services/user.service';
import { UserOperation } from '../../../../core/enums/user-operation';
import { ShiveDialogService } from '../../../../core/services/controls/shive-dialog.service';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  selector: 'app-annual-vacation-quota-dialog',
  templateUrl: './annual-vacation-quota-dialog.component.html',
  standalone: false,
})
export class AnnualVacationQuotaDialogComponent implements OnInit {
  @Input() annualVacationQuotaHistory: AnnualVacationQuotaModel[];
  public annualVacationQuotaHistoryForm: FormGroup;
  public updateEnabled = false;
  protected readonly faPenToSquare = faPenToSquare;

  // DI
  private readonly formBuilder = inject(FormBuilder);
  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  private readonly shiveDialogService = inject(ShiveDialogService);

  // Misc
  private currentIndex = -1;

  ngOnInit(): void {
    this.initForm();
  }

  public inputValueChanged(newValue: number): void {
    this.updateEnabled = newValue !== null;
    this.annualVacationQuotaHistory[this.currentIndex].amount = newValue;
  }

  public entryIndexChanged(index: number) {
    if (this.annualVacationQuotaHistory.length < index) {
      return;
    }
    this.currentIndex = index;
    this.annualVacationQuotaHistoryForm.controls.amount.patchValue(
      this.annualVacationQuotaHistory[index].amount,
    );
  }

  public close(): void {
    this.shiveDialogService.close(UserOperation.Cancel);
  }

  public submit(): void {
    this.shiveDialogService.close(this.annualVacationQuotaHistory);
  }

  private initForm(): void {
    const user = this.authService.getLoggedInUserClone();
    this.currentIndex = user.annualVacationQuotaEntries.length - 1;
    const annualVacationQuotaEntry = this.userService.getCurrentAnnualVacationQuotaEntry(user);
    this.annualVacationQuotaHistoryForm = this.formBuilder.group({
      entryIndex: this.currentIndex,
      amount: annualVacationQuotaEntry.amount,
    });
  }
}
